/* eslint-disable camelcase */
import AquariumScreen from './scenes/AquariumScreen';
import Background from './scenes/Background';
import CountFishScreen from './scenes/CountFishScreen';
import ResultScreen from './scenes/ResultScreen';
import TitleScreen from './scenes/TitleScreen';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Background, TitleScreen, CountFishScreen, ResultScreen, AquariumScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Background.KEY, // if you want to change which scene comes first, do so in the Background scene

  ROUND_COUNT: 3,
  QUESTION_COUNT: 10,
  CORRECT_SOUNDS: [{ snd: 'counting_fish-09', msg: 'correct_messages.awesome' },{ snd: 'counting_fish-11', msg: 'correct_messages.nice' }, { snd: 'counting_fish-12', msg: 'correct_messages.radical' }, { snd: 'counting_fish-10', msg: 'correct_messages.sweet' }],
  TOOMANY_SOUNDS: [{ snd: 'counting_fish-06', msg: 'incorrect_messages.too_many' }],
  TOOFEW_SOUNDS: [{ snd: 'counting_fish-05', msg: 'incorrect_messages.more' },{ snd: 'counting_fish-07',msg: 'incorrect_messages.few' }],
  MAX_FISH: 20,
  ROUND_LEVEL_INFO: [{ min: 1,max: 5 },{ min: 5,max: 10 },{ min: 10,max: 20 }],
  FISH_TYPE_COUNT: 9,
};

export const ALL_FISH_KEYS = 'AllFishes/';
export const FRIENDS_KEY = 'Friends/';

export function getCreatureOffsets (creatureid) {
  let value = null;
  const fishOffsets = [
    { types: [1,2],offsets: { body: { x: 11,y: 0 },body_outline: { x: -4,y: -4 }, eyes: { x: 43,y: 44 }, tail: { x: 0,y: 26 }, scale: 0.8 } },
    { types: [3,8,9],offsets: { body: { x: 33,y: 0 },body_outline: { x: -5,y: -4 }, eyes: { x: 61,y: 18 }, tail: { x: 0,y: 16 }, scale: 1.2 } },
    { types: [4,5],offsets: { body: { x: 36,y: 0 },body_outline: { x: -4,y: -4 }, eyes: { x: 66,y: 16 }, tail: { x: 0,y: 16 }, scale: 0.9 } },
    { types: [6,7],offsets: { body: { x: 14,y: 0 },body_outline: { x: -4,y: -4 }, eyes: { x: 55,y: 23 }, tail: { x: 0,y: 19 }, scale: 1.2 } },
    { types: ['Friend1'],offsets: { body: { x: 0,y: 0 }, eyes: { x: 58,y: 39 } } },
    { types: ['Friend2'],offsets: { body: { x: 0,y: 0 }, eyes: { x: 56,y: 10 } } },
    { types: ['Friend3'],offsets: { body: { x: 0,y: 0 }, eyes: { x: 151,y: 25 } } },
    { types: ['Friend4'],offsets: { body: { x: 0,y: 0 }, eyes: { x: 46,y: 47 } } },
    { types: ['Friend5'],offsets: { body: { x: 0,y: 0 }, eyes: { x: 43,y: 44 } } },
    { types: ['Friend6'],offsets: { body: { x: 0,y: 0 }, eyes: { x: 32,y: 14 } } }
  ];
  const len = fishOffsets.length;
  for (let i = 0; i < len; i++) {
    if (fishOffsets[i].types.indexOf(creatureid) >= 0) {
      value = fishOffsets[i];
      break;
    }
  }
  return value.offsets;
}